<div class="flex min-h-screen flex-col bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
  <header class="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4 dark:border-slate-800 dark:bg-slate-900">
    <div class="flex items-center gap-3">
      <div class="h-8 w-8 rounded bg-slate-900 dark:bg-slate-100"></div>
      <span class="text-lg font-semibold">{{ i18n.translate('app.title') }}</span>
    </div>
    <div class="flex items-center gap-2">
      <app-language-select
        [options]="languages"
        [value]="language()"
        (valueChange)="setLanguage($event)"
      />
      <app-theme-toggle
        class="ml-2"
        [isDark]="isDark()"
        (toggle)="toggleTheme()"
      />
    </div>
  </header>

  <div class="flex flex-1">
    <app-sidebar-menu />

    <main class="flex-1 p-6">
      <router-outlet />
    </main>
  </div>

  <app-footer></app-footer>
</div>
